import React, { ReactElement } from 'react';
import { PopupContainer } from '../../popups';
import { Content } from './content';
import { useCustomersSubscriptionPopupContext } from './customersSubscriptionPopup.context';
import { modalPaddings } from './customerSubscriptionPopup.meta';

export const CustomersSubscriptionPopup = (): ReactElement => {
  const { isPopupOpened, handleClosePopup, status } =
    useCustomersSubscriptionPopupContext();

  return (
    <PopupContainer
      width="600px"
      isOpened={isPopupOpened}
      closePositionRight
      closeOutside
      styleSettings={modalPaddings}
      fullHeightMobile={false}
      handleClose={handleClosePopup}
    >
      <Content status={status} />
    </PopupContainer>
  );
};
